// Document states

export default class documentState {

    ON_AGREEMENT = '2340461775000';
    APPROVED = '4951472148000';

}